import React from 'react'
import { MoreFilterLetterJump } from './MoreFilterLetterJump'
import { Button, Grid, Input, InputAdornment, makeStyles } from '@material-ui/core'
import { SearchIcon, ClearIcon, CloseSmallIcon } from '@core'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  searchBar: {
    width: '90%'
  },
  topbarWrapper: ({ isTablet }: any) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FAFAFA',
    height: 48,
    padding: isTablet ? '0px 20px' : '0px 12px'
  }),
  clearIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  },
  hiddenBtn: {
    display: 'none',
    width: 0,
    height: 0
  },
  input: {
    '&::placeholder': {
      fontSize: 12,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontStyle: 'normal'
    }
  },
  underline: {
    '&::after': {
      borderBottom: '1px solid #cccccc',
      transform: 'none'
    },
    '&:hover': {
      '&::after': {
        borderBottom: '2px solid #cccccc',
        transform: 'none'
      }
    },
    '&:focus': {
      '&::after': {
        borderBottom: '2px solid #cccccc',
        transform: 'none'
      }
    }
  },
  cursor: {
    cursor: 'pointer'
  }
}))

export const MoreFilterTopBar = ({
  data,
  filterLabel,
  handleMoreFilterPopup,
  onHandleLetter,
  onMoreFilterSearchKeyChange,
  letterToHighlight,
  handleDocumentClick,
  moreFilterSearchKey,
  setLetterToHighlight,
  isTablet
}) => {
  const classes = useStyles({ isTablet })
  const { t } = useTranslation()

  return (
    <Grid item container xs={12} className={classes.topbarWrapper}>
      <Grid item xs={isTablet ? 6 : 3} onClick={e => handleDocumentClick(e)}>
        {isTablet ? <Button className={classes.hiddenBtn} /> : null}
        <Input
          placeholder={`${t('common.label.search', 'Search')} ${filterLabel ?? ''}`}
          value={moreFilterSearchKey}
          startAdornment={
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          }
          className={classes.searchBar}
          classes={{ input: classes.input, underline: classes.underline }}
          onChange={e => {
            onMoreFilterSearchKeyChange(e.target.value)
          }}
          endAdornment={
            moreFilterSearchKey && (
              <InputAdornment position='end'>
                <CloseSmallIcon
                  onClick={() => onMoreFilterSearchKeyChange('')}
                  className={classes.cursor}
                />
              </InputAdornment>
            )
          }
        />
      </Grid>
      <Grid item xs={isTablet ? 5 : 8}>
        {!isTablet && (
          <MoreFilterLetterJump
            data={data}
            onHandleLetter={onHandleLetter}
            letterToHighlight={letterToHighlight}
            setLetterToHighlight={setLetterToHighlight}
            isTablet={isTablet}
          />
        )}
      </Grid>
      <Grid item xs={1} onClick={e => handleDocumentClick(e)}>
        <div className={classes.clearIcon} onClick={() => handleMoreFilterPopup(null)}>
          <ClearIcon />
        </div>
      </Grid>
    </Grid>
  )
}
